function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _require = require("date-fns"),
  endOfDay = _require.endOfDay,
  addMinutes = _require.addMinutes,
  startOfDay = _require.startOfDay,
  isAfter = _require.isAfter,
  formatISO = _require.formatISO,
  addSeconds = _require.addSeconds,
  getSeconds = _require.getSeconds,
  getMinutes = _require.getMinutes,
  format = _require.format;
var calcStoreOpeningTimes = function calcStoreOpeningTimes(dates, waitTime, currentTime) {
  if (!dates) {
    return [];
  }
  var days = []; // init days array
  var readyTime = addMinutes(currentTime, waitTime);
  var index = 0;
  dates.forEach(function (day, i) {
    var date = day.date,
      _day$iso = day.iso,
      start = _day$iso.start,
      end = _day$iso.end;

    // checks if days date is available and is the same as next day, if not adds to index
    if (days[index] != null && date !== days[index].date) {
      index++;
    }
    if (!days[index]) {
      days[index] = {};
    }

    // init times[index] if null
    if (!days[index].times) {
      days[index].times = [];
    }
    var dayEnd = endOfDay(new Date(start));
    var startTime = addMinutes(startOfDay(new Date(start)), waitTime);
    var storeCloseTime = new Date(end);

    // when date have after 12 am picking/delivery hours
    if (isAfter(storeCloseTime, dayEnd)) {
      // adds the day start and adding the end of the day
      if (isAfter(dayEnd, currentTime)) {
        days[index].times.push({
          start: formatISO(startTime),
          end: formatISO(dayEnd)
        });
        days[index].date = date;
        index++;
      }
      // fixing next day hours in date if the next day is in the array
      if (i + 1 < dates.length) {
        var nextDayEndTime = addSeconds(storeCloseTime, 1);
        var nextDayStartTime = startOfDay(nextDayEndTime);
        days[index] = {};
        days[index].times = [{
          start: formatISO(nextDayStartTime),
          end: formatISO(nextDayEndTime)
        }];
        days[index].date = format(nextDayEndTime, 'yyyy-MM-dd');
      }
    }
    // only by day delivery/pick up times
    else {
      var endTime = addSeconds(storeCloseTime, 1);
      if (isAfter(endTime, readyTime)) {
        days[index].times.push({
          start: formatISO(startTime),
          end: formatISO(endTime)
        });
        days[index].date = date;
        index++;
      }
    }
  });
  return days;
};
var calcOrderTimes = function calcOrderTimes(dayDetails, waitTime, currentTime, interval) {
  var hours = [];
  var orderDay = new Date(dayDetails.date);
  var isToday = isSameDay(orderDay, currentTime) || isSameDay(addMinutes(currentTime, waitTime), orderDay); // checks if delivery/checkoutItemOrder time is today

  dayDetails.times.forEach(function (times) {
    var lastHour = new Date(times.end);
    var startTime = new Date(times.start);

    // fix hour by the time of the day
    if (isToday) {
      var nowWithWait = addMinutes(currentTime, waitTime);
      nowWithWait = subSeconds(nowWithWait, getSeconds(nowWithWait) % 60);
      if (isAfter(nowWithWait, startTime)) {
        startTime = nowWithWait;
      }
    }

    // rounds minutes to given interval
    var startTimeMinutes = getMinutes(startTime);
    if (startTimeMinutes % interval !== 0) {
      var delta = interval - startTimeMinutes % interval;
      // startTime = startTime.add(15 - (startTimeMinutes % 15), 'm');
      startTime = addMinutes(startTime, delta);
    }

    // adds the hours range to hours labels
    hours = [].concat(_toConsumableArray(hours), _toConsumableArray(createRangeTimes(startTime, lastHour, interval)));
  });
  return hours;
};

// creates array range between hour and last hour each hour by 15 min distance
var createRangeTimes = function createRangeTimes(hour, lastHour, interval) {
  var hours = [];
  for (; isAfter(lastHour, hour); hour = addMinutes(hour, interval)) {
    var startHour = format(hour, 'h:mm a');
    hours.push({
      key: startHour,
      label: startHour
    });
  }
  return hours;
};
module.exports = {
  calcStoreOpeningTimes: calcStoreOpeningTimes,
  calcOrderTimes: calcOrderTimes
};